// Keys are dated: when a key's stored schema changes shape, mint a new dated
// key so a row written under the old shape is never parsed as the new one.
export const IS_COLOR_THEME_DARK = 'sso-is-color-theme-dark-09-04-2026';
export const WATCHLIST = 'sso-watchlist-09-04-2026';
